var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"portal-content-wrap ptBG1"},[_c('div',{staticClass:"maxWidth"},[_c('MyInfoWebpart'),(!_vm.isOutsourcingRole)?_c('MyCountWebpart'):_vm._e(),(!_vm.isOutsourcingRole)?_c('NoticeTicker'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }